import { useQueryClient } from '@tanstack/react-query'

import { Message, QueryChatArgs } from '@tribeplatform/gql-client/types'

import { useQuery } from '../../lib/react-query/useQuery.js'
import { getPendingMessagesKey } from '../../utils/keys/messaging.key.js'

export type PendingMessage = Pick<
  Message,
  | '_id'
  | 'nonce'
  | 'content'
  | 'images'
  | 'attachments'
  | 'embeds'
  | 'authorId'
  | 'authorParticipantId'
  | 'contentType'
  | 'sentAt'
  | 'authorName'
> & {
  status: 'pending' | 'error'
}

export const usePendingMessages = (options: { variables: QueryChatArgs }) => {
  const queryClient = useQueryClient()
  const pendingMessagesKey = getPendingMessagesKey({
    variables: options.variables,
  })

  return useQuery<PendingMessage[]>(
    pendingMessagesKey,
    () => queryClient.getQueryData<PendingMessage[]>(pendingMessagesKey) || [],
    {
      initialData: [],
    },
  )
}
